<template>
  <div>
    <div>
      <v-app-bar
        :src="require('@/assets/back_navbar.png')"
        app
        prominent
        color="#000000"
        dark
      >
        <v-app-bar-title></v-app-bar-title>
        <v-app-bar-nav-icon class="onlyMobile" @click.stop="navBtn"></v-app-bar-nav-icon>

        <v-row>
          <v-col cols="4">
            <img class="onlyDesktop" style="height: 7rem" src="@/assets/logo2.png" />
            <img class="onlyMobile" style="height: 5rem" src="@/assets/logo2.png" />
          </v-col>

          <router-link id="inicio" to="/">
            <v-btn class="btn-class onlyDesktop" color="#000000" elevation="8"
              >Inicio</v-btn
            >
          </router-link>
          <router-link id="CDCD" to="/barrepro">
            <v-btn class="btn-class onlyDesktop" color="#000000" elevation="8"
              >Conócenos</v-btn
            >
          </router-link>

          <!-- Si eres cliente -->
          <div v-if="$store.state.authModule.role == 'customer'">
            <router-link id="CDCD" to="/my_space">
              <v-btn class="btn-class onlyDesktop" color="#000000" elevation="8"
                >Mi Espacio</v-btn
              >
            </router-link>

            <router-link id="CDCD" to="/biblioteca">
              <v-btn class="btn-class onlyDesktop" color="#000000" elevation="8"
                >Videos</v-btn
              >
            </router-link>

            <router-link id="paquetes" to="/precio">
              <v-btn class="btn-class onlyDesktop" color="#000000" elevation="8"
                >Precios</v-btn
              >
            </router-link>

            <!-- <router-link id="paquetes" to="/renew">
              <v-btn class="btn-class onlyDesktop" color="#000000" elevation="8"
                >Renovar en Línea</v-btn
              >
            </router-link> -->
          </div>
          <!-- Si eres admin -->
          <div v-if="$store.state.authModule.role == 'admin'">
            <router-link id="CDCD" to="/biblioteca">
              <v-btn class="btn-class onlyDesktop" color="#000000" elevation="8"
                >Videos</v-btn
              >
            </router-link>

            <router-link id="paquetes" to="/user_admin">
              <v-btn class="btn-class onlyDesktop" color="#000000" elevation="8"
                >Administrar</v-btn
              >
            </router-link>
            <router-link id="paquetes" to="/subir_video">
              <v-btn class="btn-class onlyDesktop" color="#000000" elevation="8"
                >Subir Video</v-btn
              >
            </router-link>
            <router-link id="paquetes" to="/en_vivo">
              <v-btn class="btn-class onlyDesktop" color="rgba(0,0,0,0)" elevation="8"
                >En Vivo</v-btn
              >
              <v-icon class="onlyDesktop" style="margin-top: 5rem !important" color="red">
                mdi-video
              </v-icon>
            </router-link>
          </div>
          <!-- si eres guest -->
          <div v-if="$store.state.authModule.role == 'guest'">
            <router-link id="paquetes" to="/precio">
              <v-btn class="btn-class onlyDesktop" color="#000000" elevation="8"
                >Precios</v-btn
              >
            </router-link>
          </div>
          <!-- Stream -->
          <router-link
            id="paquetes"
            to="/en_vivo"
            v-if="live && $store.state.authModule.role == 'customer'"
          >
            <v-btn class="btn-class onlyDesktop" color="rgba(0,0,0,0)" elevation="8"
              >En Vivo</v-btn
            >
            <v-icon class="onlyDesktop" style="margin-top: 5rem !important" color="red">
              mdi-video
            </v-icon>
          </router-link>
          <v-spacer />
          <v-btn
            v-if="$store.state.authModule.logged"
            @click="logoutNav"
            color="#777777"
            elevation="8"
            class="btn-class onlyDesktop"
            ><v-icon dark>mdi-logout </v-icon></v-btn
          >
          <div v-else>
            <router-link id="sesion" to="/login">
              <v-icon
                class="onlyDesktop"
                style="margin-top: 5rem !important"
                color="#777777"
              >
                mdi-account-arrow-right
              </v-icon>
              <v-btn class="btn-class onlyDesktop" color="#777777" elevation="8"
                >Iniciar Sesión
              </v-btn>
            </router-link>
            <router-link id="sesion" to="/registrar">
              <v-icon
                class="onlyDesktop"
                style="margin-top: 5rem !important"
                color="#777777"
              >
                mdi-account-multiple-plus
              </v-icon>
              <v-btn class="btn-class onlyDesktop" color="#777777" elevation="8"
                >Registrate
              </v-btn>
            </router-link>
          </div>
        </v-row>
      </v-app-bar>

      <!-- Vista Movil -->
      <div id="drawerDiv">
        <v-navigation-drawer
          style="background-color: rgb(0, 0, 0)"
          v-model="drawer2"
          absolute
          temporary
          app
        >
          <router-link to="/">
            <v-btn @click="navBtn" class="btn-classDrawer" color="#000000" elevation="8"
              >Inicio</v-btn
            >
          </router-link>
          <router-link id="CDCD" to="/barrepro">
            <v-btn class="btn-classDrawer" color="#000000" elevation="8">Conócenos</v-btn>
          </router-link>
          <!-- Si eres cliente -->
          <div v-if="$store.state.authModule.role == 'customer'">
            <router-link to="/my_space">
              <v-btn class="btn-classDrawer" color="#000000" elevation="8">Mi Espacio</v-btn>
            </router-link>
            <router-link to="/biblioteca">
              <v-btn class="btn-classDrawer" color="#000000" elevation="8">Videos</v-btn>
            </router-link>

            <router-link to="/precio">
              <v-btn class="btn-classDrawer" color="#000000" elevation="8">Precios</v-btn>
            </router-link>
            
            <!-- <router-link to="/renew">
              <v-btn class="btn-classDrawer" color="#000000" elevation="8">Renovar en Línea</v-btn>
            </router-link> -->
          </div>

          <div v-if="$store.state.authModule.role == 'admin'">
            <router-link to="/biblioteca">
              <v-btn class="btn-classDrawer" color="#000000" elevation="8">Videos</v-btn>
            </router-link>
            <router-link to="/user_admin">
              <v-btn class="btn-classDrawer" color="#000000" elevation="8"
                >Administrar</v-btn
              >
            </router-link>
            <router-link to="/subir_video">
              <v-btn class="btn-classDrawer" color="#000000" elevation="8"
                >Subir Video</v-btn
              >
            </router-link>
            <router-link to="/en_vivo">
              <v-icon style="margin-top: 2rem !important" color="red"> mdi-video </v-icon>
              <v-btn class="btn-classDrawer" color="rgba(0,0,0,0)" elevation="8"
                >En Vivo
              </v-btn>
            </router-link>
          </div>

          <div v-if="$store.state.authModule.role == 'guest'">
            <router-link to="/precio">
              <v-btn class="btn-classDrawer" color="#000000" elevation="8">Precios</v-btn>
            </router-link>
          </div>
          <!-- Stream -->
          <router-link
            v-if="live && $store.state.authModule.role == 'customer'"
            to="/en_vivo"
          >
            <v-icon style="margin-top: 2rem !important" color="red"> mdi-video </v-icon>
            <v-btn class="btn-classDrawer" color="rgba(0,0,0,0)" elevation="8"
              >En Vivo
            </v-btn>
          </router-link>
          <br />
          <v-btn
            v-if="$store.state.authModule.logged"
            @click="logoutNav"
            color="#777777"
            elevation="8"
            class="btn-classDrawer"
            ><v-icon dark>mdi-logout </v-icon></v-btn
          >
          <div v-else>
            <router-link to="/login">
              <v-icon style="margin-top: 2rem !important" color="#777777">
                mdi-account-arrow-right
              </v-icon>
              <v-btn class="btn-classDrawer" color="#777777" elevation="8"
                >Iniciar Sesión
              </v-btn>
            </router-link>
            <br />
            <router-link to="/registrar">
              <v-icon style="margin-top: 2rem !important" color="#777777">
                mdi-account-multiple-plus
              </v-icon>
              <v-btn class="btn-classDrawer" color="#777777" elevation="8"
                >Registrarte
              </v-btn>
            </router-link>
          </div>
        </v-navigation-drawer>
      </div>
    </div>
  </div>
</template>
<script>
import { db } from "@/main";
export default {
  name: "navBar",
  data() {
    return {
      drawer2: false,
      group: null,
      live: null,
    };
  },
  created: async function () {
    window.addEventListener("resize", this.windowWidth);
    await db
      .collection("stream")
      .doc("url")
      .onSnapshot(async (urldoc) => {
        this.live = urldoc.data().enabled;
      });
  },
  destroyed() {
    window.removeEventListener("resize", this.windowWidth);
  },
  methods: {
    navBtn() {
      try {
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth",
        });
      } catch (error) {
        window.scrollTo(0, 0);
      }

      this.drawer2 = !this.drawer2;
    },
    //cerrar sesion en firebase y regresar el state de vuex al inicial
    logoutNav: async function () {
      await this.$store.dispatch("firebaseLogout").then(() => {
        this.$store.commit("setUser");
        this.$store.commit("setRole", "guest");
        this.$store.commit("setName", "");

        this.$router.push("/login");
      });
    },
    drawer() {
      this.$store.commit("changeDrawer", true);
    },
    windowWidth() {
      this.size = window.innerWidth;
      return this.size;
    },
  },
};
</script>
<style scoped>
a {
  text-decoration: none;
}
@media (max-width: 1024px) {
  .onlyMobile {
    display: inline-flex;
  }
  .onlyDesktop {
    display: none !important;
  }
}
@media (min-width: 1024px) {
  .onlyMobile {
    display: none !important;
  }
  .onlyDesktop {
    display: inline-flex;
  }
}
#drawerDiv button {
  margin-top: 0.3rem;
  background-color: rgb(14, 145, 140);
  color: white;
  text-align: left;
  font-family: Poiret One, sans-serif !important;
}
#drawerDiv {
  background-color: rgb(14, 145, 140);
}
.btn-class {
  font-size: 1rem;
  text-transform: capitalize;
  margin-top: 5rem !important;
  padding-bottom: 1.2rem;
  margin-right: 1rem;
  font-family: Poiret One, sans-serif !important;
}
.btn-classDrawer {
  font-size: 1rem;
  text-transform: capitalize;
  margin-top: 2rem !important;
}

@media screen and (max-width: 1230px) {
  #inicio {
    width: 8% !important;
  }
}

@media screen and (max-width: 1187px) {
  #CDCD {
    width: 9% !important;
  }
}

@media screen and (max-width: 1140px) {
  #paquetes {
    width: 22% !important;
  }

  #inicio {
    width: 8% !important;
  }

  #CDCD {
    width: 8% !important;
  }

  #inicio button {
    font-size: 0.8em;
  }

  #CDCD button {
    font-size: 0.8em;
  }

  #paquetes button {
    font-size: 0.8em;
  }

  #sesion button {
    font-size: 0.8em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navbar.vue